import React from 'react'
import {Stack} from '@mui/material'
import {Link} from  'react-router-dom'
import {logo} from '../utils/constants'
import SearchBar from './SearchBar'


const Navbar = () => (
  <Stack 
  direction="row" 
  alignItems="center" 
  p={2} 
  sx={{ 
    position:'Sticky', 
    background:'#000', 
    top:0, 
    justifyContent: 'space-between',
    borderBottom: "1px #fb1602 solid",
    zIndex: '1000'}}
  >
    <Link to="/" style={{display:'flex', alignItems: 'center'}}>
      <img src={logo} alt="logo" height={45} />
      </Link>
      <SearchBar />
  </Stack>
)

export default Navbar